<form #customerAdminFormRef="ngForm" [formGroup]="customerAdminForm" autocomplete="off">
  <div class="row g-3">
    <div class="col-lg-4">
      <mat-form-field class="w-100">
        <mat-label >Email</mat-label>
        <input   matInput type="email" *ngIf="operation !== 'view'" formControlName="email" placeholder="Enter Email"
          (input)="validateEmail($event)" name="email" required maxlength="50">
        <input matInput *ngIf="operation === 'view'" readonly
          [value]="customerDetails?.email_id? customerDetails.email_id: '-'">
        <mat-hint class="text-danger" *ngIf="!isEmailValid && customerAdminForm.get('email')?.touched">Please enter valid email</mat-hint>
      </mat-form-field>
    </div>

    <div class="col-lg-4">
      <mat-form-field class="w-100">
        <mat-label>First Name</mat-label>
        <input matInput type="text" *ngIf="operation !== 'view'" (keypress)="onlyAlphabet($event)" maxlength="25"
          (paste)="onPaste($event,'firstName')" formControlName="firstName" placeholder="Enter First Name"
          name="firstName" required>
        <input matInput *ngIf="operation === 'view'" readonly
          [value]="customerDetails?.first_name? customerDetails.first_name: '-'">

      </mat-form-field>
    </div>

    <div class="col-lg-4">
      <mat-form-field class="w-100">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" *ngIf="operation !== 'view'" (keypress)="onlyAlphabet($event)" maxlength="25"
          (paste)="onPaste($event,'lastName')" formControlName="lastName" placeholder="Enter Last Name" name="lastName">
        <input matInput *ngIf="operation === 'view'" readonly
          [value]="customerDetails?.last_name? customerDetails.last_name: '-'">
      </mat-form-field>
    </div>


    <div class="col-lg-6 mb-3">
      <div class="form-group ">
        <form #primaryMobileFormRef="ngForm" [formGroup]="primaryMobileForm">
          <mat-form-field class="w-100">
            <mat-label>Mobile Number</mat-label>
            <ngx-mat-intl-tel-input *ngIf="operation !== 'view'"
              [enablePlaceholder]="true" [enableSearch]="true"
              [maxLength]="15" [phoneValidation]="true"
              [cssClass]="'custom'"
              [searchCountryFlag]="true"
              [required]="true"
              [preferredCountries]="['in','us', 'ca']"
              [enablePlaceholder]="true"
              name="primaryMobileNo"
              formControlName="primaryMobileNo" #phone (input)="checkLength($event)">
            </ngx-mat-intl-tel-input>
            <mat-error *ngIf="!isPrimaryMobileNoValid">
              *Invalid Phone Number
            </mat-error>
            <input matInput *ngIf="operation === 'view'" readonly [value]="customerDetails.mobile_number">
            
          </mat-form-field>
        </form>
      </div>
    </div>

    <div class="col-lg-6">
      <mat-form-field class="w-100">
        <mat-label>User Name</mat-label>
        <input matInput *ngIf="operation !== 'view'" type="text" (keypress)="onlyLowerCaseAlphabet($event)"
          maxlength="25" (paste)="onPaste($event,'username')" formControlName="username" placeholder="Enter User Name"
          name="username" required>
        <input matInput *ngIf="operation === 'view'" readonly
          [value]="customerDetails?.username? customerDetails.username: '-'">

      </mat-form-field>
    </div>

  </div>

  <div class="d-flex justify-content-end gap-2 mt-4">
    <button type="button" mat-raised-button (click)="navigateToCustomerList()">Cancel</button>
    <button type="submit" *ngIf="operation === 'new' || !customerDetails"
      [disabled]="customerAdminForm.invalid || !isEmailValid || primaryMobileForm.invalid"
      (click)="addOrEditCustomerAdmin()" mat-raised-button color="primary"> Continue
    </button>
  </div>
</form>